@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Dashboard - Controle de Clientes</div>
    </div>
    <!-- Filtro -->
    <div class="pt-3 pr-4 pb-0 pl-4">
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="form-row">
          <!-- Período -->
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Dt. Inicial:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" formControlName="dt_inicial" />
          </div>
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Dt. Final:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" formControlName="dt_final" />
          </div>
          <!-- Cliente -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Cliente:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_cliente" formControlName="cliente" />
          </div>
          <!-- Vendedor(a) -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Vendedor(a):</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_vendedor" formControlName="vendedor" />
          </div>
          <div class="col-sm-2">
            <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
            @if (filtrado) {
              <button class="btn btn-secondary btn_filtro" type="button" (click)="removerFiltros()">Cancelar</button>
            }
          </div>
        </div>
      </form>
      <hr class="mt-2 mb-2" />
    </div>
    @if (filtrado) {
      <div class="pt-2 pr-4 pb-4 pl-4">
        <div class="d-flex flex-wrap align-content-start justify-content-center">
          <!-- Vendas Total -->
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-dollar quadros_numeros_icones"></i>
              </div>
              <div class="quadros_numeros_textos">
                {{ valorVendasTotal | currency: 'BRL' }}<br />Vendas Total
              </div>
            </div>
          </div>
          <!-- Top 5 -->
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-users quadros_numeros_icones"></i>
              </div>
              <div class="quadros_numeros_textos">
                {{ top5Clientes | currency: 'BRL' }}<br />Top 5 Clientes
              </div>
              <div class="quadros_numeros_porcentagem">
                {{ porcentagemTop5Clientes | currency: 'BRL' : '' }}%
              </div>
            </div>
          </div>
          <!-- Top 10 -->
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-users quadros_numeros_icones"></i>
              </div>
              <div class="quadros_numeros_textos">
                {{ top10Clientes | currency: 'BRL' }}<br />Top 10 Clientes
              </div>
              <div class="quadros_numeros_porcentagem">
                {{ porcentagemTop10Clientes | currency: 'BRL' : '' }}%
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Movimentação de Visitas e Pedidos por Cliente -->
        <div class="d-flex justify-content-between">
          <div class="movimentacao_visitas_pedidos flex-grow-1">
            <div class="text-center p-2">
              <b>Movimentação de Visitas e Pedidos por Cliente</b>
            </div>
            @if (ordenarTextoControleClientes != '') {
              <div class="ordenar_texto text-secondary mb-2"><b>{{ ordenarTextoControleClientes }}</b></div>
            }
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th class="ordenar_coluna" (click)="ordernarControleClientes('fullname')">Vendedor(a)</th>
                        <th class="ordenar_coluna tabela_borda" (click)="ordernarControleClientes('name')">Cliente</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordernarControleClientes('ultima_visita')">Ult. Visita</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordernarControleClientes('qtde_visitas')">Qtde Visitas</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordernarControleClientes('ultimo_pedido')">Ult. Pedido</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordernarControleClientes('qtde_pedidos')">Qtde Pedidos</th>
                        <th class="ordenar_coluna text-right tabela_borda" (click)="ordernarControleClientes('total_pedido')">Total: R$</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let controleCliente of controleClientes; templateCacheSize: 0; templateCacheSize: 0;">
                        <td>{{ controleCliente.fullname }}</td>
                        <td class="tabela_borda">{{ controleCliente.name }}</td>
                        <td class="text-center tabela_borda">{{ controleCliente.ultima_visita | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        <td class="text-center tabela_borda">{{ controleCliente.qtde_visitas }}</td>
                        <td class="text-center tabela_borda">{{ controleCliente.ultimo_pedido | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        <td class="text-center tabela_borda">{{ controleCliente.qtde_pedidos }}</td>
                        <td class="text-right tabela_borda">{{ controleCliente.total_pedido | currency: 'BRL' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Acumulado por Vendedor -->
        <div class="d-flex justify-content-between">
          <div class="acumulado_por_vendedor flex-grow-1">
            <div class="text-center p-2">
              <b>Acumulado por Vendedor</b>
            </div>
            @if (ordenarTextoControleClientesVendedor != '') {
              <div class="ordenar_texto text-secondary mb-2"><b>{{ ordenarTextoControleClientesVendedor }}</b></div>
            }
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th class="ordenar_coluna" (click)="ordenarControleClientesVendedor('fullname')">Vendedor(a)</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordenarControleClientesVendedor('qtde_visitas')">Qtde Visitas</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordenarControleClientesVendedor('qtde_pedidos')">Qtde Pedidos</th>
                        <th class="ordenar_coluna text-right tabela_borda" (click)="ordenarControleClientesVendedor('total_pedido')">Total: R$</th>
                        <th class="ordenar_coluna text-right tabela_borda" (click)="ordenarControleClientesVendedor('ticket_medio')">Ticket Médio: R$</th>
                        <th class="ordenar_coluna text-center tabela_borda" (click)="ordenarControleClientesVendedor('mix')">Mix</th>
                        <th class="ordenar_coluna text-right tabela_borda" (click)="ordenarControleClientesVendedor('margem')">Margem: %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let controleClienteVendedor of controleClientesVendedor; templateCacheSize: 0;">
                        <td>{{ controleClienteVendedor.fullname }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteVendedor.qtde_visitas }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteVendedor.qtde_pedidos }}</td>
                        <td class="text-right tabela_borda">{{ controleClienteVendedor.total_pedido | currency: 'BRL' }}</td>
                        <td class="text-right tabela_borda">{{ controleClienteVendedor.ticket_medio | currency: 'BRL' }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteVendedor.mix }}</td>
                        <td class="text-right tabela_borda">{{ controleClienteVendedor.margem | currency: 'BRL' : '' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Clientes s/ Visita >= 30 dias / Clientes s/ Visita >= 60 dias -->
        <div class="d-flex flex-wrap justify-content-between">
          <div class="sem_visita_esquerda flex-grow-1">
            <div class="text-center p-2">
              <b>Clientes s/ Visita >= 30 dias</b>
            </div>
            <div class="p-2">
              <div class="d-flex flex-wrap align-content-start justify-content-center">
                <!-- Qtde Clientes -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-users quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeClientes }}<br />Qtde Clientes
                    </div>
                  </div>
                </div>
                <!-- Qtde s/ Visita -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-users quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeClientesSemVisita30Dias }}<br />Qtde s/ Visita
                    </div>
                    <div class="quadros_numeros_porcentagem">
                      {{ porcentagemSemVisita30Dias | currency: 'BRL' : '' }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Vendedor(a)</th>
                        <th class="tabela_borda">Cliente</th>
                        <th class="text-center tabela_borda">CNPJ/CPF</th>
                        <th class="text-center tabela_borda">Telefone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let controleClienteSemVisita30Dias of controleClientesSemVisita30Dias; templateCacheSize: 0;">
                        <td>{{ controleClienteSemVisita30Dias.fullname }}</td>
                        <td class="tabela_borda">{{ controleClienteSemVisita30Dias.name }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteSemVisita30Dias.client_document }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteSemVisita30Dias.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
          <div class="sem_visita_direita flex-grow-1">
            <div class="text-center p-2">
              <b>Clientes s/ Visita >= 60 dias</b>
            </div>
            <div class="p-2">
              <div class="d-flex flex-wrap align-content-start justify-content-center">
                <!-- Qtde Clientes -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-users quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeClientes }}<br />Qtde Clientes
                    </div>
                  </div>
                </div>
                <!-- Qtde s/ Visita -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-users quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeClientesSemVisita60Dias }}<br />Qtde s/ Visita
                    </div>
                    <div class="quadros_numeros_porcentagem">
                      {{ porcentagemSemVisita60Dias | currency: 'BRL' : '' }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Vendedor(a)</th>
                        <th class="tabela_borda">Cliente</th>
                        <th class="text-center tabela_borda">CNPJ/CPF</th>
                        <th class="text-center tabela_borda">Telefone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let controleClienteSemVisita60Dias of controleClientesSemVisita60Dias; templateCacheSize: 0;">
                        <td>{{ controleClienteSemVisita60Dias.fullname }}</td>
                        <td class="tabela_borda">{{ controleClienteSemVisita60Dias.name }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteSemVisita60Dias.client_document }}</td>
                        <td class="text-center tabela_borda">{{ controleClienteSemVisita60Dias.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
